/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Invoice } from './Invoice';
// @ts-ignore
import {
// @ts-ignore
    InvoiceFromJSON,
// @ts-ignore
    InvoiceFromJSONTyped,
// @ts-ignore
    InvoiceToJSON,
} from './Invoice';

/**
 * 
 * @export
 * @interface InvoiceListResponse
 */
export interface InvoiceListResponse {
    /**
     * 
     * @type {number}
     * @memberof InvoiceListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<Invoice>}
     * @memberof InvoiceListResponse
     */
    items: Array<Invoice>;
}

/**
 * Check if a given object implements the InvoiceListResponse interface.
 */
// @ts-ignore
export function instanceOfInvoiceListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function InvoiceListResponseFromJSON(json: any): InvoiceListResponse {
    return InvoiceListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function InvoiceListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(InvoiceFromJSON)),
    };
}

// @ts-ignore
export function InvoiceListResponseToJSON(value?: InvoiceListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(InvoiceToJSON)),
    };
}

